import { get, isEmpty } from 'lodash';
import { formatAmount } from '../../helpers/fieldHelpers';
import { getAccountBySortCodeAccountNumber } from '../../states/accounts/selectors';

export const CLEAR_IMPORTED_PAYMENT_LIST = 'CLEAR_IMPORTED_PAYMENT_LIST';
export const UPDATE_IMPORTED_PAYMENT_LIST = 'UPDATE_IMPORTED_PAYMENT_LIST';

export const clearImportedPaymentList = () => ({
	type: CLEAR_IMPORTED_PAYMENT_LIST,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updateImportedPaymentList = (payments, date) => (dispatch, getState) => {
	const newPaymentList = payments.map((payment) => {
		const {
			from: { sortCode, accountNumber },
		} = payment;
		const state = getState();
		const accountDetails = getAccountBySortCodeAccountNumber(state, sortCode, accountNumber);
		const fromAccount = get(accountDetails, 'id', '');
		const displayName = get(accountDetails, 'metadata.display_name', '') || get(accountDetails, 'displayName', '');
		return {
			...payment,
			fromAccount,
			from: {
				displayName,
				sortCode,
				accountNumber,
			},
			date,
			amount: formatAmount(payment.amount),
		};
	});

	return dispatch({
		type: UPDATE_IMPORTED_PAYMENT_LIST,
		payments: newPaymentList,
	});
};
